import React, { useCallback } from 'react';
import CameraIcon from '@quintoandar/cozy-icons/Camera';
import ContentHeader from 'components/ContentHeader';
import messages from './messages';

export const Header = () => {
  const setIcon = useCallback(() => <CameraIcon fontSize="small" />);

  const instructions =
    [{
      message: { ...messages.instructionHeaderCardDescription },
      bold: { ...messages.instructionHeaderCardDescriptionItems },
    },
    {
      message: { ...messages.secondInstructionHeaderCardDescription },
      bold: { ...messages.secondInstructionHeaderCardDescriptionBoldItem },
    },
    {
      message: { ...messages.thirdInstructionHeaderCardDescription },
      bold: { ...messages.thirdInstructionHeaderCardDescriptionBoldItem },
    },
    {
      message: { ...messages.fourthInstructionHeaderCardDescription },
      bold: { ...messages.fourthInstructionHeaderCardDescriptionBoldItem },
    },
    {
      message: { ...messages.fifthInstructionHeaderCardDescription },
      bold: { ...messages.fifthInstructionHeaderCardDescriptionBold },
    }];

  return (
    <ContentHeader
      headerTitle={messages.instructionHeaderTitle}
      instructionsCardTitle={messages.instructionHeaderCardTitle}
      instructionsCardTitleIcon={setIcon}
      instructions={instructions}
    />
  );
};

export default Header;
